/**
 * @author xxx
 * 模块说明：渠道库存同步任务例外规则日志管理
 */

import { Service } from '@/tools'
export class ChannelStockTaskRuleLogService <T extends TStock.ChannelStockTaskRuleLog> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.ChannelStockTaskRuleLog}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  
            
  /**
   * 功能：查询例外规则
   */
  getRuleByTaskId = (data: T['ApiGetRuleByTaskId']['req']): Promise<T['ApiGetRuleByTaskId']['res']> => this.post2('v1/ApiGetRuleByTaskId', data)
}
